export class OvertimeApplicationsService {
  constructor(API, Auth) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.employeeUrl = '/user/overtime-application';
    this.TLVorManagerUrl = '/users/overtime-application';
  }

  createApplication(data, isEmployeeApplication) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}${isEmployeeApplication ? this.employeeUrl : this.TLVorManagerUrl}`,
      data: data
    });
  }

  getApplications(isEmployeeApplication, accessLevel, allPendingRequests) {
    const params = {
      accessLevel: isEmployeeApplication ? 'Employee' : accessLevel
    };

    if (allPendingRequests)
      params.allTeams = true;

    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}${isEmployeeApplication ? this.employeeUrl : this.TLVorManagerUrl}`,
      params: params
    });
  }

  editApplication(uuid, data, isEmployeeApplication) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `${isEmployeeApplication ? this.employeeUrl : this.TLVorManagerUrl}/${uuid}`,
      data: data
    });
  }

  deleteApplication(uuid, isEmployeeApplication) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `${isEmployeeApplication ? this.employeeUrl : this.TLVorManagerUrl}/${uuid}`
    });
  }

  acceptsApplication(uuid, data, approverId) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `${this.TLVorManagerUrl}/${uuid}`,
      data: {
        comment: data.comment || null,
        acceptedBy: approverId,
        lastUpdate: data.eventAt
      }
    });
  }

  commentApplication(uuid, data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/overtime-application/${uuid}/comment`,
      data: data
    });
  }

  employeeFormData() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/user/overtime-application/create-view'
    });
  }

  managerOrTLSubordinateUsers(viewType) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams/subordinate/users',
      params: {
        accessLevel: viewType
      }
    });
  }

  managerOrTLUserClients(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/users/${userId}/active-clients`
    });
  }

  managerOrTLCreateView(userId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/users/${userId}/overtime-application/create-view`
    });
  }

  getPossibleApplicationsForUser(userId, clientId, startedAt, worklogId) {
    const params = {
      clientId: clientId,
      startedAt: startedAt
    };

    if (worklogId)
      params.worklogId = worklogId;

    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/users/overtime-application/for-user/${userId}`,
      params: params
    });
  }

  getPossibleApplicationsForEmployee(userId, clientId, startedAt, worklogId) {
    const params = {
      clientId: clientId,
      startedAt: startedAt
    };

    if (worklogId)
      params.worklogId = worklogId;

    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/user/overtime-application/worklog-view`,
      params: params
    });
  }

  getAllocations(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/users/overtime-application/${id}/allocates`
    });
  }

  saveAllocation(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + `/users/overtime-application/${id}/allocates`,
      data: data
    });
  }

  getSettlements(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/users/overtime-application/${id}/settlements`
    });
  }

  saveSettlement(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + `/users/overtime-application/${id}/settlements`,
      data: data
    });
  }

  getTLVAnnulas(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/users/overtime-application-annuals/${id}`
    });
  }

  getMVAnnuals(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/management/users/overtime-application-annuals/${id}`
    });
  }

  getEmployeeAnnuals() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/user/overtime-application-annuals`
    });
  }

  saveAnnual(data, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + `/${isManagement ? 'management/' : ''}/users/overtime-application-annuals`,
      data: data
    });
  }

  rejectApplication(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/users/overtime-application/${id}`,
      data: data
    });
  }

  getWorklogsForApplication(id) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/users/overtime-application/${id}/worklogs`
    });
  }
}
